import { render, staticRenderFns } from "./SceneAudio.vue?vue&type=template&id=81c3499e&"
import script from "./SceneAudio.vue?vue&type=script&lang=js&"
export * from "./SceneAudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports